"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowGroupToggle = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../Icons/PetSure/Icon");
var _TableProps = require("../TableProps");
var _hooks = require("../../../../hooks");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const RowGroupToggle = _ref => {
  let {
    row,
    ungroupLabel = 'Ungroup cells',
    groupLabel = 'Group and aggregate cells',
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const rowGroupToggleButton = (0, _react.useRef)(null);
  (0, _hooks.useTracking)({
    elementRef: rowGroupToggleButton,
    trackingProps: {
      label: row.isExpanded ? ungroupLabel : groupLabel,
      elementType: 'button'
    },
    customTrackingData,
    customTrackingEvents
  });
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    ref: rowGroupToggleButton,
    className: "tableRowGroupControl ".concat(row.isExpanded ? 'tableGroupControl_grouped' : ''),
    type: "button"
  }, row.getToggleRowExpandedProps()), row.isExpanded ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, ungroupLabel), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "api-connect"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, groupLabel), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "api-connect"
  })));
};
exports.RowGroupToggle = RowGroupToggle;
RowGroupToggle.propTypes = {
  row: _propTypes.default.shape(_TableProps.TableRowProps),
  ungroupLabel: _propTypes.default.string,
  groupLabel: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};